import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { EkskulSiswaPage } from './ekskul-siswa.page';

const routes: Routes = [
  {
    path: '',
    component: EkskulSiswaPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [EkskulSiswaPage]
})
export class EkskulSiswaPageModule {}
